import { FieldValues } from 'react-hook-form'

import {
  TextAreaInput,
  TextAreaInputProps,
} from '~/components/component-library'
import { useRequireMemo } from '~/hooks/org'

type TransactionMemoInputProps<FormType extends FieldValues> = Omit<
  TextAreaInputProps<FormType>,
  'id' | 'placeholder' | 'required' | 'className' | 'optional'
>

export const TransactionMemoInput = <
  FormType extends FieldValues = FieldValues,
>(
  props: TransactionMemoInputProps<FormType>,
) => {
  const requireMemo = useRequireMemo()
  const tooltip =
    props.tooltip ||
    'Stored offchain and visible to anyone you share this transaction with'

  return (
    <TextAreaInput
      {...props}
      id="memo"
      optional={!requireMemo}
      requiredErrorMessage="A memo is required"
      maxLength={1000}
      placeholder="A description for your team and recipients"
      label={requireMemo ? 'Memo (required)' : 'Memo'}
      tooltip={tooltip}
    />
  )
}
